import * as yup from 'yup'

const schema = yup.object({
  name: yup.string().min(4).max(150).required(),
  number: yup.string().min(16).max(23).required().cardNumber(),
  month: yup.string().required(),
  year: yup.number().required(),
  cvv: yup
    .string()
    .min(3, 'Código Inválido')
    .max(4, 'Código Inválido')
    .required(),
  document: yup.string().required().cpfOrCnpj(),
})
export default schema
